var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0"},[_c('router-view'),_c('div',{staticStyle:{"width":"100vw","height":"56px"}}),_c('bottom-navigation')],1)}
var staticRenderFns = []

export { render, staticRenderFns }